<template>
  <v-app-bar
    absolute
    color="transparent"
    flat
    height="85"
  >
    <v-container>
      <v-row align="center">
        <v-toolbar-title
          class="font-weight-light"
          v-text="title"
        />

        <v-spacer />

        <v-btn
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          class="ml-10 hidden-sm-and-down"
          min-height="48"
          text
        >
          <v-icon
            left
            size="24"
            v-text="item.icon"
          />

          <span v-text="item.text" />
        </v-btn>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  export default {
    name: 'PagesCoreAppBar',

    data: () => ({
      items: [
        {
          icon: 'mdi-account-multiple-plus',
          text: 'Register',
          to: '/pages/register'
        },
        {
          icon: 'mdi-fingerprint',
          text: 'Login',
          to: '/pages/login'
        },
        {
          icon: 'mdi-lock-open-outline',
          text: 'Lock',
          to: '/pages/lock'
        }
      ],
      titles: {
        '/pages/lock': 'Lock Page',
        '/pages/login': 'Login',
        '/pages/register': 'Create New Account'
      }
    }),
    computed: {
      title () {
        return this.titles[this.$route.path]
      },
      error () {
        return this.$store.getters.error
      }
    },
    methods: {
      onDismissed () {
        this.$store.dispatch('clearError')
      },
      submit () {
        this.checking = true
        this.$store.dispatch('signUserIn', { email: this.form.email, password: this.form.password })
        setTimeout(() => {
          if (this.$store.getters.user && !this.$store.getters.error) {
            this.snackbar = true
            this.resetForm()
            this.$v.$reset()
            this.$router.push({
              name: 'dashboard/Dashboardv2'
            })
          }
        }, 2000)
        this.checking = false
      }
    }
  }
</script>
